module.exports = __webpack_public_path__ + "img/SA.8a68f2b3.jpg";